// @ts-nocheck
// Store Sync - LoadVariantChildren

import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import {
    GetProductVariantChildrenApiV2Parameter,
    getVariantChildren,
} from "@insite/client-framework/Services/ProductServiceV2";
import { ProductCollectionModel, ProductModel, VariantTraitModel } from "@insite/client-framework/Types/ApiModels";

/* Store Custom Code - Start */
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    getLoadVariantIdForProducts,
    loadProductRequiredExpands,
    loadProductRequiredParameters,
    setLoadVariantIdForProduct,
} from "@store/Framework/Common/Utilities/loadProductHelper";
/* Store Custom Code - End */

type Parameter = { products: ProductModel[] } & HasOnSuccess<ProductModel[]>; // Store Custom Code
type Props = {
    apiParameter: GetProductVariantChildrenApiV2Parameter;
    apiResult: ProductCollectionModel;
    // Store Custom Code
    productId: string;
    variantTraits?: VariantTraitModel[];
};

type HandlerType = Handler<Parameter, Props>;

/* Store Custom Code - Start */
export const PopulateProps: HandlerType = props => {
    props.productId = getLoadVariantIdForProducts(props.parameter.products);
    props.variantTraits = props.parameter.products.find(x => x.variantTraits)?.variantTraits;
};
/* Store Custom Code - End */

export const DispatchBeginLoadProducts: HandlerType = props => {
    props.dispatch({
        type: "Data/Products/BeginLoadProducts",
        parameter: {
            productId: props.productId, // Store Custom Code
            variantChildren: true,
        },
    });
};

/* Store Custom Code - Start */
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        productId: props.productId,
        pageSize: 500,
    };

    if (getSettingsCollection(props.getState()).emserCatalogSettings.loadProductVariantAsync) {
        props.apiParameter.expand = ["properties"];
    } else {
        props.apiParameter = {
            ...props.apiParameter,
            ...loadProductRequiredParameters,
            // We remove "variantTraits" from the call and inherit them from the product instead (RequestDataFromApi)
            expand: loadProductRequiredExpands.filter(x => x !== "variantTraits"),
        };
    }
};
/* Store Custom Code - End */

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getVariantChildren(props.apiParameter);
};

/* Store Custom Code - Start */
export const PopulateApiResult: HandlerType = props => {
    props.apiResult.products?.forEach(x => {
        setLoadVariantIdForProduct(x, props.productId);
        if (props.variantTraits && !x.variantTraits) {
            x.variantTraits = props.variantTraits;
        }
    });
};
/* Store Custom Code - End */

export const DispatchCompleteLoadProducts: HandlerType = props => {
    props.dispatch({
        type: "Data/Products/CompleteLoadProducts",
        collection: props.apiResult,
        parameter: {
            productId: props.productId, // Store Custom Code
            variantChildren: true,
        },
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult.products!);
};

export const chain = [
    PopulateProps, // Store Custom Code
    PopulateApiParameter,
    DispatchBeginLoadProducts,
    RequestDataFromApi,
    PopulateApiResult, // Store Custom Code
    DispatchCompleteLoadProducts,
    ExecuteOnSuccessCallback,
];

const loadVariantChildrens = createHandlerChainRunner(chain, "LoadVariantChildrens");
export default loadVariantChildrens;
